import React, {useContext} from "react"
import {buildClassList} from "../helpers/utilities"
import {CONTAINER_LG, CONTAINER_XL} from "../helpers/constants"
import HeaderNav from "./HeaderNav"
import HeaderNavItem from "./HeaderNavItem"
import OfficialSiteBanner from "./OfficialSiteBanner"
import IRSLogo from "../Icons/IRSLogo"
import Link from "../Links"
import SiteContext from "../context/SiteContext"

const HeaderLogo = (props) => {
  const { logoLinkPath="https://www.irs.gov/", children } = props

    return (
      <Link
        href={logoLinkPath}
        className="logo block h-8-5 w-24 my-4 lg:w-25 lg:h-9"
        aria-label="IRS Home"
      >
        {children}
      </Link>
    )
}

const Header = ({
  headerNavItems,
  mobileHeaderNavItems,
  title,
  children,
  ...props }) => {

  const {site, menuState, width} = useContext(SiteContext)


  const headerNavDesktop = (
    <div className="flex flex-grow hidden lg:block my-4">
      <HeaderNav className="headerNav">
        { headerNavItems &&
          Object.values(headerNavItems).map(({ text, ...rest }) =>
            <HeaderNavItem {...rest}>
              { text }
            </HeaderNavItem>
          )
        }
      </HeaderNav>
    </div>
  )

  const headerNavMobile = (
    <div className="flex justify-end flex-grow lg:hidden mt-4 uppercase">
      <HeaderNav className="headerNav">
        { mobileHeaderNavItems &&
          Object.values(mobileHeaderNavItems).map(({ text, toggleText, ...rest }) =>
            <HeaderNavItem 
              className="uppercase" 
              {...rest}
            >
              {menuState ? toggleText : text}
            </HeaderNavItem>
          )
        }
      </HeaderNav>
    </div>
  )

  return (
    <header aria-label="Site" className={buildClassList([
      "top-0 lg:relative z-40",
      width < CONTAINER_LG ? "isStickyNav" : ""
    ])}>
      <a className="skipnav absolute p-6 left-0 bg-transparent" tabIndex="0" title="Skip to main content" aria-label="Skip to main content" href="#main-content">
        Skip to main content
      </a>

      <OfficialSiteBanner message={site.headerMessage} />
      <div className="header bg-blue-600">
          <div style={{ maxWidth: `${CONTAINER_XL}px` }} className="flex relative px-5 mx-auto">
            <HeaderLogo {...props} logoLinkTitle={title}>
              <IRSLogo className="h-8-5 w-24 lg:w-25 lg:h-auto text-white" focusable="false"/>
            </HeaderLogo>
            {headerNavMobile}
            {headerNavDesktop}
          </div>
        </div>
    </header>
  )
}

export default Header